<template>
    <md-card>
        <headful
			:title="'Caseen Admin - ' + userStats.uname"
		/>
        <br>
        <h2>User Profile</h2>
        <br>
        <svg width="100" height="100" :data-jdenticon-value="userData.pid" style="border: 2px solid #555;"></svg>
        <br>
        <b>{{userStats.uname}}#{{userData.pid.slice(0, 5)}}</b>
        <br>
        <hr>
        <table>
            <tr>
                <td>
                    <b>Public ID:</b>
                    <br>
                    {{userData.pid}}
                </td>
                <td>
                    <b>User ID:</b>
                    <br>
                    {{userData.id}}
                </td>
            </tr>
            <tr>
                <td>
                    <b>Full Name:</b>
                    <br>
                    {{userData.fullName}}
                </td>
                <td>
                    <b>Username:</b>
                    <br>
                    {{userData.uname}}
                </td>
            </tr>
            <tr>
                <td>
                    <b>Email:</b>
                    <br>
                    {{userData.email}}
                </td>
                <td>
                    <b>Auth Provider:</b>
                    <br>
                    {{userData.authProvider}}
                </td>
            </tr>
            <tr v-if="userData.training">
                <td>
                    <b>Training Level:</b>
                    <br>
                    {{userData.training.level}}
                </td>
                <td>
                    <b>Training Year:</b>
                    <br>
                    {{userData.training.year}}
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <b>Accepted TOS:</b>
                    <br>
                    {{userData.acceptedTOS}}
                </td>
            </tr>
            <tr>
                <td>
                    <b>Registered Educator:</b>
                    <br>
                    <select v-model="userData.isEducator">
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                    </select>
                </td>
                <td>
                    <b>Premium User:</b>
                    <br>
                    <select v-model="userData.isPremium">
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                    </select>
                </td>
            </tr>
            <tr>
                <td>
                    <b>Admin Privleges:</b>
                    <br>
                    {{userData.isAdmin}}
                </td>
                <td>
                    <b>Owner Privleges:</b>
                    <br>
                    {{userData.isOwner}}
                </td>
            </tr>
            <tr>
                <td colspan=2>
                    <md-button class="md-primary md-raised" v-show="JSON.stringify(userData) != JSON.stringify(originalUserData)" @click="saveUser">
                        Save Changes
                    </md-button>
                    <h2><i>User Stats</i></h2>
                </td>
            </tr>
            <tr>
                <td colspan=2>
                    <b><u>Learner Score</u>:</b>
                    <br>
                    {{userStats.learnerScore}}
                </td>
            </tr>
            <tr>
                <td>
                    <b>Cases Completed:</b>
                    <br>
                    {{userStats.casesCompleted}}
                </td>
                <td>
                    <b>Cases Reviewed:</b>
                    <br>
                    {{userStats.casesReviewed}}
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <b><u>Author Score</u>:</b>
                    <br>
                    {{userStats.authorScore}}
                </td>
            </tr>
            <tr>
                <td>
                    <b>Cases Owned:</b>
                    <br>
                    {{userStats.casesOwned}}
                </td>
                <td>
                    <b>Cases Collaborated:</b>
                    <br>
                    {{userStats.casesCollaborated}}
                </td>
            </tr>
            <tr>
                <td>
                    <b>Author Quality:</b>
                    <br>
                    <star-rating 
                        read-only
                        v-model="userStats.authorQuality"
                        :show-rating="false"
                        :max-rating="5" 
                        :increment="0.1"
                        :star-size="18" 
                        style="display: inline-block">
                    </star-rating>
                    <br>
                    {{userStats.authorQuality.toFixed(1)}}
                </td>
                <td>
                    <b>Author Difficulty:</b>
                    <br>
                    <star-rating 
                        read-only
                        v-model="userStats.authorDifficulty"
                        :show-rating="false"
                        :max-rating="3" 
                        :increment="0.1"
                        :star-size="18" 
                        style="display: inline-block">
                    </star-rating>
                    <br>
                    {{userStats.authorDifficulty.toFixed(1)}}
                </td>
            </tr>
        </table>
        <br><br>
        <h2>User Cases</h2>
        <CaseList :userProfile="userData.pid"/>
        <br><br>
    </md-card>
</template>

<script>
    import StarRating from 'vue-star-rating'
    import APIRequests from "../APIRequests.js"
    import CaseList from "../CaseList.vue"
    
    export default {
        components: {
            StarRating,
            CaseList,
        },
        props: {
            userID: {
                type: String
            }
        },
        data: function(){
            return {
                userData: {},
                originalUserData: {},
                userStats: {},
                userCaseList: [],
            }
        },
        methods: {
            fetchUserData: function(){
                var api_url = this.$store.state.api_url + "/api/users/getProfile/" + this.userID
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    this.userData = data
                    this.originalUserData = JSON.parse(JSON.stringify(data))
                })
            },
            fetchUserStats: function(publicID){
                var api_url = this.$store.state.api_url + "/api/users/userStats/" + publicID
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    this.userStats = data
                })
            },
            saveUser: function(){
                APIRequests.postJSONData(
                    this.$store.state.api_url + "/api/users/updateProfile/" + this.userData.id, 
                    this.userData,
                    this.$store.state.jwtToken
                ).then(() => {
                    window.location.reload()
                }).catch((xhrResp) => {
                    alert("Error, failed to save profile edits:\n" + xhrResp[1])
                }) 
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.fetchUserData().then(() => {
                    this.fetchUserStats(this.userData.pid)
                })
            })
        }
    }
</script>

<style>
    table{
        overflow: scroll;
        width: 100%;
        text-align: center;
    }
    td{
        border-bottom: 1px dotted black;
        padding: 7px;
    }
</style>